import { gql } from "@apollo/client";

const ProjectsSubscription = gql`
  subscription ProjectsSubscription {
    listen(topic: "project_update") {
      query {
        allProjects(orderBy: PROJECT_NAME_ASC) {
          nodes {
            id
            projectName
            isActive
            uploadCount: uploadsByProjectName {
              count: totalCount
            }
            photos: photosByProjectName {
              count: totalCount
            }
            addedOn
          }
        }
      }
    }
  }
`;

const hash = "8fc607c8209a52094bab9fe172f691dc15e99af82ab8c73ba1e41ce17bae4273";

export { ProjectsSubscription, hash };
